function Bibliography() {
	return (<>
		<section id="bibliography">
			<header className="major">
				<h2>
					Recent Publications
					<span style={{marginLeft: "18px"}}>
						<a href="#main" className="icon fa-caret-square-up">
							<span className="label">Back to top</span>
						</a>
					</span>
				</h2>
			</header>
			<ol>
				<li className="bibEntry">
					<p>
						Khan, S., <span className="textbf">Iqbal, M.</span>, Osho, O., Singh, K., Derrick, K., Nelson, P., Li, L., 
						Sidnam-Mauch, E., Bannister, N., Caine, K., & Knijnenburg, B. (2024).
					</p>
					<p className="title">
						Teaching Middle Schoolers about the Privacy Threats of Tracking and Pervasive Personalization: 
						A Classroom Intervention Using Design-Based Research,
					</p>
					<p>
						Proceedings of the 2024 CHI Conference on Human Factors in Computing Systems
					</p>
				</li>
				<li className="bibEntry">
					<p>
						Singh, K., Sidnam-Mauch E., <span className="textbf">Iqbal, M.</span>, Osho, O., Khan, S.,
						Nelson, P., Derrick, K., Caine, K., Knijnenburg, B., & Bannister, N. (2022).
					</p>
					<p className="title">
						TRUST THE TEACHERS! Conducting School-Based Research in a Rural Middle School When Building 
						Relationships Face-to-Face Is Not Possible (Outtake article),
					</p>
					<p>
						Curriculum and Teaching Dialogue, Volume 24, Numbers 1 & 2, pp. 269-274
						Copyright © 2022 by Information Age Publishing www.infoagepub.com
					</p>
				</li>
				<li className="bibEntry">
					<p>
						Baracskay, I., Baracskay III, D. J., <span className="textbf">Iqbal, M.</span>, & Knijnenburg, B. P. (2022).
					</p>
					<p className="title">
						The Diversity of Music Recommender Systems.
					</p>
					<p>
						27th International Conference on Intelligent User Interfaces, 97-100.
						https://doi.org/10.1145/3490100.3516474
					</p>
				</li>
				<li className="bibEntry">
					<p>
						Oganian, A., <span className="textbf">Iqbal, M.</span>, & Lesaja, G. (2021).
					</p>
					<p className="title">
						Extreme value protection adjustment for different subpopulations in complex data sets.
					</p>
					<p>
						UNECE Conference on European Statisticians. Expert Meeting on Data Confidentiality.
					</p>
				</li>
				<li className="bibEntry">
					<p>
						Khan, S., <span className="textbf">Iqbal, M.</span>, Humaira, N., Hubig, N., & Knijnenburg, B. (2021).
					</p>
					<p className="title">
						Mitigating Digital Mindlessness.
					</p>
					<p>
						AI of AI. International Joint Conferences on Artificial Intelligence.
					</p>
				</li>
			</ol>
		</section>
	</>)
}

export default Bibliography;